import React, { useState } from 'react'
import { Button, ErrorText, Field, SectionTitle, inputClass } from './ui'
import { translateError } from '../../api/auth'
import { apiFetch } from '../../api/apiFetch'

const AUTH_BASE = process.env.REACT_APP_AUTH_API_URL || '/api/auth/browser/v1'

const readCookie = (name) => {
  const m = document.cookie.match(new RegExp(`(^|;\s*)${name}=([^;]*)`))
  return m ? decodeURIComponent(m[2]) : null
}

/**
 * Zmianę hasła obsługuje allauth, a nie nasze API konta.
 * Świadomie nie dublujemy tej logiki: allauth ma własne limity prób i wysyła
 * powiadomienie o zmianie hasła na adres użytkownika. Własna implementacja
 * musiałaby to wszystko odtworzyć — i byłaby kolejnym miejscem na błąd.
 */
const PasswordSection = ({ setFlash }) => {
  const [form, setForm] = useState({ current: '', next: '', next2: '' })
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }))

  const submit = async (e) => {
    e.preventDefault()
    setError('')
    if (form.next !== form.next2) { setError('Nowe hasła nie są takie same.'); return }

    setBusy(true)
    let res, body
    try {
      res = await apiFetch(`${AUTH_BASE}/auth/password/change`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-CSRFToken': readCookie('csrftoken') || '' },
        credentials: 'same-origin',
        body: JSON.stringify({ current_password: form.current, new_password: form.next }),
      })
      body = await res.json().catch(() => ({}))
    } catch {
      setBusy(false)
      setError('Brak połączenia z serwerem. Spróbuj ponownie.')
      return
    }
    setBusy(false)

    const bledy = body.errors || []
    if (bledy.length) { setError(bledy.map((x) => translateError(x.message)).join(' ')); return }
    if (!res.ok && res.status !== 401) { setError('Nie udało się zmienić hasła.'); return }

    setForm({ current: '', next: '', next2: '' })
    setFlash('Hasło zostało zmienione. Wysłaliśmy powiadomienie na Twój adres.')
  }

  return (
    <form onSubmit={submit}>
      <SectionTitle hint="Po zmianie wyślemy powiadomienie na Twój adres — żebyś wiedział, gdyby zmienił je ktoś inny.">
        Zmiana hasła
      </SectionTitle>

      <div className="grid gap-4 max-w-md">
        <Field label="Obecne hasło">
          <input type="password" autoComplete="current-password" className={inputClass}
                 value={form.current} onChange={set('current')} disabled={busy} required />
        </Field>
        <Field label="Nowe hasło" hint="Co najmniej 8 znaków. Unikaj popularnych haseł.">
          <input type="password" autoComplete="new-password" className={inputClass}
                 value={form.next} onChange={set('next')} disabled={busy} required />
        </Field>
        <Field label="Powtórz nowe hasło">
          <input type="password" autoComplete="new-password" className={inputClass}
                 value={form.next2} onChange={set('next2')} disabled={busy} required />
        </Field>
      </div>

      <div className="mt-4"><ErrorText>{error}</ErrorText></div>

      <div className="mt-5">
        <Button type="submit" busy={busy}>Zmień hasło</Button>
      </div>
    </form>
  )
}

export default PasswordSection
